<div class="modal fade" [id]="modalId" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content p-1">
      <div class="modal-header dirI">
        <h5 class="modal-title">ضبط صدا</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="recorder" [class.is-recording]="isAudioRecording" [class.is-done]="!isAudioRecording && isAudioRecorded()">
          <!-- آماده ضبط -->
          <ng-container *ngIf="!isAudioRecording && !isAudioRecorded()">
            <button type="button" class="rec-btn" (click)="startAudioRecording()" title="شروع ضبط">
              <i class="fa fa-microphone"></i>
            </button>
            <div class="rec-title">ضبط صدا <span class="req">*</span></div>
            <div class="rec-sub">برای شروع ضبط لمس کنید (حداکثر ۶۰ ثانیه)</div>
          </ng-container>
          <!-- در حال ضبط -->
          <ng-container *ngIf="isAudioRecording && !isAudioRecorded()">
            <button type="button" class="rec-btn recording" (click)="stopAudioRecording()" title="توقف ضبط">
              <i class="fa fa-square"></i>
            </button>
            <div class="rec-title">در حال ضبط…</div>
            <div class="rec-timer">{{ audioRecordedTime | faNum }}</div>
            <button type="button" class="btn btn-outline-danger btn-sm" (click)="stopAudioRecording()">توقف ضبط</button>
          </ng-container>
          <!-- ضبط شده -->
          <ng-container *ngIf="!isAudioRecording && isAudioRecorded()">
            <div class="rec-done-head">
              <span class="rec-ok"><i class="fa fa-check-circle"></i> صدا ضبط شد</span>
              <button type="button" class="btn btn-light btn-sm" (click)="clearRecordedAudio()" title="حذف و ضبط مجدد">
                <i class="fa fa-trash"></i> حذف
              </button>
            </div>
            <audio *ngIf="audioSrcUrl" controls class="w-100 rounded">
              <source [src]="audioSrcUrl" type="audio/mp3">
              Your browser does not support the audio element.
            </audio>
          </ng-container>
        </div>
      </div>
      <div class="modal-footer">
        <div class="col-12 d-flex justify-content-end">
          <!-- <button class="btn btn-sm btn-secondary px-4" data-bs-dismiss="modal">بستن</button> -->
          <button class="btn btn-sm btn-success px-4" [disabled]="!isAudioRecorded() || isSending" (click)="send()">
            <i class="fa" [ngClass]="isSending ? 'fa-spinner fa-spin' : 'fa-send'"></i>
            {{ isSending ? 'در حال ارسال' : 'ارسال' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
